// Shared timing helpers for the Market Probabilities board's MTD candlestick
// machine (use-mtd-candles). Factored out of the provider so the effect hook and
// the provider read the SAME constants. No React, no WS state -- pure values +
// one date helper, unit-testable in isolation.
//
// NOTE (IM-1954): the client-side generic_pricer fan-out is retired -- the board
// now reads touch probabilities from the `subscribe.market_probabilities` feed
// (see use-market-probabilities-feed.ts). The fan-out's pacing/stagger/watchdog
// knobs went with it; only the MTD-candle timing survives here.

export const MTD_REFRESH_MS = 60000; // realized extremes move slowly; 1-min poll
// Per-market MTD-candle response watchdog. A wrong-venue (or just unanswered)
// candlestick request can silently drop with no handler callback, which would
// otherwise leave mtdStatus pinned at 'pending' forever and the card blank.
// If no response lands within this window we dispatch MTD_ERROR so the card
// shows the honest "no MTD data" state and the next poll retries. Mirrors the
// 15s safety timeout in use-available-tokens.ts; kept a touch tighter so a
// stuck market recovers before the 60s MTD poll would re-fire anyway.
export const MTD_TIMEOUT_MS = 13000;

export const floorToMinute = (d: Date): Date => new Date(d.getTime() - (d.getTime() % 60000));
